export enum OrderMenuType {
  // 体验版-600分钟
  TRIAL_SIX_HUNDRED_MINUTE = "TRIAL_SIX_HUNDRED_MINUTE",
  // 企业版-6000分钟
  ENTERPRISE_SIX_HUNDRED_MINUTE = "ENTERPRISE_SIX_HUNDRED_MINUTE",
  // 专业版-1000小时
  PROFESSIONAL_ONE_THOUSAND_HOUR = "PROFESSIONAL_ONE_THOUSAND_HOUR",
  // 专业版-100小时
  PROFESSIONAL_ONE_HUNDRED_HOUR = "PROFESSIONAL_ONE_HUNDRED_HOUR",
}

export interface IOrderDetail {
  orderId: string;
  duration: string;
  price: number;
  description: string;
  account: string;
}

export enum PayResult {
  // 初始化
  INIT = "INIT",
  // 待支付
  WAIT_BUYER_PAY = "WAIT_BUYER_PAY",
  // 支付成功
  TRADE_SUCCESS = "TRADE_SUCCESS",
  // 交易关闭
  TRADE_CLOSED = "TRADE_CLOSED",
  // 交易失败
  TRADE_ERROR = "TRADE_ERROR",
  // 支付结束
  TRADE_FINISH = "TRADE_FINISH",
}

export interface IPayResult {
  payResult: PayResult;
  createdDate: string;
}

export interface IPostOrderPayParams {
  orderId: string;
  payChannel: PayChannel;
  paySubChannel: PaySubChannel;
  openId: string;
}

export interface IPostOrderPayRes {
  payId: string;
  payChannel: PayChannel;
  paySubChannel: PaySubChannel;
  prepayInfo: string;
}

export enum PayChannel {
  WECHATPAY = "WECHATPAY",
}

export enum PaySubChannel {
  WECHAT_SCAN = "WECHAT_SCAN",
  WECHAT_JSAPI = "WECHAT_JSAPI",
}

export interface WxOrderInfo{
  appid: string;
  noncestr: string;
  package: string;
  packageValue: string;
  paysign: string;
  signtype: string;
  timestamp: string;
}